import normalizeEntity from '@flow/libs/normalized-redux/entity-normalizer';

const normalizedRoles = normalizeEntity<Oneflow.Role, 'role', string[]>({
  entity: 'role',
});

export default normalizedRoles;
